import script from "./RecRadioButtons.vue?vue&type=script&setup=true&lang=ts&generic=T"
export * from "./RecRadioButtons.vue?vue&type=script&setup=true&lang=ts&generic=T"

import "./RecRadioButtons.vue?vue&type=style&index=0&id=18e53d0c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18e53d0c"]])

export default __exports__